/* HomeMedix two-pane filter drawer + collection filter bar (Oct 13, 2026). See assets/hm-filter-drawer.css.
   Works on top of snippets/facets.liquid: adds a nav of filter groups, shows one group at a time, a search box for long lists,
   and a footer (Clear all = the theme's own clear link, Show products = close). Filtering itself is still the theme's facets.js. */
(function () {
  if (window.__hfd) return;
  window.__hfd = true;
  var X = '<svg viewBox="0 0 10 10" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7"></path></svg>';
  var MAG = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="20" y1="20" x2="16.2" y2="16.2"></line></svg>';
  var pending = null, cur = null, busy = false;
  function sb() { return document.getElementById('sidebar'); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function label(d) {
    var l = d.querySelector('.facets__summary-label');
    if (!l) return '';
    var c = l.cloneNode(true), x = c.querySelector('.facets__selected');
    if (x) x.parentNode.removeChild(x);
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function count(d) {
    var x = d.querySelector('.facets__selected');
    if (!x || x.classList.contains('hidden')) return '';
    var m = x.textContent.match(/\d+/);
    return m && m[0] !== '0' ? m[0] : '';
  }
  function addSearch(d) {
    if (d.querySelectorAll('li.facets__item').length <= 10 || d.querySelector('.hfd-search')) return;
    var box = d.querySelector('.facets__display-vertical');
    if (!box) return;
    var w = document.createElement('label'), name = label(d);
    w.className = 'hfd-search';
    w.innerHTML = MAG + '<input type="search" placeholder="Search ' + esc(name.toLowerCase()) + '" aria-label="Search ' + esc(name) + '">';
    box.insertBefore(w, box.firstChild);
    var inp = w.querySelector('input');
    function stop(e) { e.stopPropagation(); }
    inp.addEventListener('change', stop);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    inp.addEventListener('input', function (e) {
      e.stopPropagation();
      var q = inp.value.trim().toLowerCase();
      d.querySelectorAll('li.facets__item').forEach(function (li) {
        var hit = !q || li.textContent.toLowerCase().indexOf(q) > -1;
        li.style.display = hit ? '' : 'none';
        if (q) li.classList.remove('hidden');
      });
    });
  }
  function render() {
    var s = sb();
    if (!s || busy || !s.classList.contains('hfd')) return;
    busy = true;
    try {
      var gs = Array.prototype.slice.call(s.querySelectorAll('details.js-filter'));
      if (!gs.length) return;
      if (!cur || !document.getElementById(cur)) cur = gs[0].id;
      var html = '';
      gs.forEach(function (d) {
        var on = d.id === cur, n = count(d);
        d.classList.toggle('hfd-cur', on);
        if (on && !d.open) d.open = true;
        html += '<button type="button" class="hfd-g' + (on ? ' is-on' : '') + '" data-hfd-g="' + esc(d.id) + '"' + (on ? ' aria-current="true"' : '') + '><span>' + esc(label(d)) + '</span>' + (n ? '<b>' + n + '</b>' : '') + '</button>';
      });
      var nav = s.querySelector('.hfd-nav');
      if (nav && nav.innerHTML !== html) nav.innerHTML = html;
      var d = document.getElementById(cur), t = s.querySelector('.hfd-title');
      if (t && d) { var lt = label(d); if (t.textContent !== lt) t.textContent = lt; }
      if (d) addSearch(d);
      var clr = s.querySelector('.hfd-clear');
      if (clr) clr.hidden = !document.querySelector('.active-facets-desktop .active-facets__button-remove');
    } finally {
      busy = false;
    }
  }
  function setup() {
    var s = sb();
    if (!s) return null;
    if (s.classList.contains('hfd')) return s;
    var form = s.querySelector('facet-filters-form');
    if (!form || !form.querySelector('details.js-filter')) return null;
    s.classList.add('hfd');
    var hide = document.getElementById('hideFiltersBtn');
    if (hide) { hide.innerHTML = X; hide.setAttribute('aria-label', 'Close filters'); }
    var nav = document.createElement('nav');
    nav.className = 'hfd-nav';
    nav.setAttribute('aria-label', 'Filters');
    s.insertBefore(nav, form);
    var t = document.createElement('div');
    t.className = 'hfd-title';
    form.insertBefore(t, form.firstChild);
    var foot = document.createElement('div');
    foot.className = 'hfd-foot';
    foot.innerHTML = '<button type="button" class="hfd-clear">Clear all</button><button type="button" class="hfd-go">Show products</button>';
    s.appendChild(foot);
    foot.addEventListener('click', function (e) {
      if (e.target.closest('.hfd-go')) { var h = document.getElementById('hideFiltersBtn'); if (h) h.click(); }
      if (e.target.closest('.hfd-clear')) { var r = document.querySelector('.active-facets-desktop .active-facets__button-remove'); if (r) r.click(); }
    });
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hfd-g]');
      if (!b) return;
      e.preventDefault();
      cur = b.getAttribute('data-hfd-g');
      render();
      form.scrollTop = 0;
    });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { render(); }).observe(form, { childList: true, subtree: true });
      new MutationObserver(function () {
        if (!s.classList.contains('open')) return;
        if (pending) { select(pending); pending = null; } else render();
      }).observe(s, { attributes: true, attributeFilter: ['class'] });
    }
    render();
    return s;
  }
  function select(key) {
    var s = setup();
    if (!s) return;
    var d = document.getElementById(key) || s.querySelector('details.js-filter[id^="Details-' + String(key).replace(/"/g, '\\"') + '-"]');
    if (d) cur = d.id;
    render();
    var f = s.querySelector('facet-filters-form');
    if (f) f.scrollTop = 0;
  }
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-hms-open],[data-hcb-open],[data-hms-all],[data-hcb-all],#showFiltersBtn') : null;
    if (!t) return;
    setup();
    var key = t.getAttribute('data-hms-open') || t.getAttribute('data-hcb-open');
    if (t.hasAttribute('data-hcb-all') || t.hasAttribute('data-hcb-open')) {
      e.preventDefault();
      e.stopPropagation();
      if (key) pending = key;
      var btn = document.getElementById('showFiltersBtn');
      if (btn) btn.click();
    } else if (key) {
      pending = key;
    }
    var s = sb();
    if (key && s && s.classList.contains('open')) { select(key); pending = null; }
  }, true);
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-hcb-sort]') : null;
    if (!sel) return;
    var tb = document.getElementById('SortBy-toolbar'), dr = document.getElementById('SortBy-drawer');
    if (dr) dr.value = sel.value;
    if (tb) {
      tb.value = sel.value;
      tb.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      window.location.href = u.toString();
    }
  });
  function syncBar() {
    var src = document.getElementById('ProductCount'), ct = document.querySelector('[data-hcb-count]');
    if (src && ct) { var tx = src.textContent.replace(/\s+/g, ' ').trim(); if (tx && ct.textContent !== tx) ct.textContent = tx; }
    var n = document.querySelector('[data-hcb-n]');
    if (n) {
      var c = document.querySelectorAll('.facets__form-vertical input[type="checkbox"]:checked').length;
      if (Array.prototype.some.call(document.querySelectorAll('.facets__price input'), function (i) { return i.value; })) c += 1;
      var v = c > 0 ? String(c) : '';
      if (n.textContent !== v) n.textContent = v;
    }
  }
  function boot() {
    setup();
    if (!document.getElementById('showFiltersBtn')) {
      document.querySelectorAll('[data-hcb-all],[data-hcb-open]').forEach(function (b) { b.hidden = true; });
    }
    var src = document.getElementById('ProductCount');
    if (src && document.querySelector('.hcb') && 'MutationObserver' in window) new MutationObserver(syncBar).observe(src, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
